export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 7a3.5 3.5 0 107 0V3h2v4a5.5 5.5 0 01-4.5 5.407V15.5a4 4 0 007.913.827 3.5 3.5 0 112.023.045A6 6 0 017.5 15.5v-3.093A5.5 5.5 0 013 7V3h2v4zm13.5 4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};